import {
  DOWNLOAD_LOG_REQUEST,
  DOWNLOAD_LOG_SUCCESS,
  DOWNLOAD_LOG_FAILURE
} from './actions';

const initialState = {
  logDownload: {
    loading: false,
    error: null,
    blob: null
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case DOWNLOAD_LOG_REQUEST:
      return {
        ...state,
        logDownload: { loading: true, error: null, blob: null }
      };
    case DOWNLOAD_LOG_SUCCESS:
      return {
        ...state,
        logDownload: { loading: false, error: null, blob: action.blob }
      };
    case DOWNLOAD_LOG_FAILURE:
      return {
        ...state,
        logDownload: { loading: false, error: action.error, blob: null }
      };
    default:
      return state;
  }
}
